import { createSlice } from "@reduxjs/toolkit";
import { IGetReportsPayload } from "../../models/report.model";
import { getReportThunk } from "../actions/report.action";

export interface ReportState {
  loading: boolean;
  error: string | null;
}

export const initialState: ReportState = {
  loading: false,
  error: null,
};

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default reportSlice.reducer;